import { FilterField, FilterFieldType } from '../filter';

export class CheckboxFilterField extends FilterField<boolean> {
  readonly type: FilterFieldType = 'checkbox';

  public clearValue(): void {
    this.value = false;
    if (this.valueChanged) {
      this.valueChanged(this);
    }
  }

  appliedFieldText(): string {
    return this.name;
  }
}
